import {defaultScrolls} from '../consts/scrolls';

export const sortByName = (a, b) => a.name.localeCompare(b.name, ['en', 'ru'], { numeric: true });

export const sortByType = (a, b) => b.type - a.type;

export const mergeWithDefault = (scrolls, locale) =>
    [...scrolls, ...defaultScrolls[locale]?.filter(d => !scrolls.some(s => s.name === d.name))];
